
import { Options, Vue } from 'vue-class-component';
import Contacts from '@/components/Contacts.vue';
import Logo from "@/base-components/Logo.vue"; // @ is an alias to /src

@Options({
  components: {
    Contacts,
    Logo
  },
})
export default class ContactsView extends Vue {}
